import Loadable from 'react-loadable';

const AsyncPolices = Loadable({
  loader: () =>
    import('./screens/Explore/TermsServices' /* webpackChunkName: "TermsServices" */),
  modules: ['TermsServices'],
  webpack: () => [require.resolveWeak('./screens/Explore/TermsServices')],
  loading: 'Loading',
  delay: 300,
});

const AsyncCareer = Loadable({
  loader: () => import('./screens/Page/Career' /* webpackChunkName: "Careers" */),
  modules: ['Careers'],
  webpack: () => [require.resolveWeak('./screens/Page/Career')],
  loading: 'Loading',
  delay: 300,
});

export { AsyncPolices, AsyncCareer };



// WEBPACK FOOTER //
// ./src/AsyncApp.js